exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error[data-v-717050be]{margin:0 auto;max-width:80%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./Scripts/app/profiles/components/ErrorAlert.vue?vue&type=style&index=0&id=717050be&prod&scoped=true&lang=css
// module id = 532
// module chunks = 0